var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnread = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C2.96254 0.5 0.5 2.96232 0.5 6C0.5 9.03768 2.96254 11.5 6 11.5C9.03746 11.5 11.5 9.03746 11.5 6C11.5 2.96254 9.03768 0.5 6 0.5Z",
    fill: "#F0BA15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05257 8.07557C7.93831 8.18979 7.78337 8.25395 7.62181 8.25395C7.46025 8.25395 7.30531 8.18979 7.19105 8.07557L5.57005 6.4535C5.51199 6.39554 5.46626 6.32643 5.43562 6.25033C5.40497 6.17423 5.39004 6.09272 5.39173 6.0107C5.39173 6.00684 5.39173 6.00318 5.39173 5.99932V2.41594C5.39173 2.25434 5.45592 2.09936 5.57019 1.9851C5.68445 1.87083 5.83943 1.80664 6.00103 1.80664C6.16262 1.80664 6.3176 1.87083 6.43187 1.9851C6.54613 2.09936 6.61032 2.25434 6.61032 2.41594V5.77029L8.05386 7.21383C8.11039 7.27048 8.1552 7.33771 8.18573 7.41169C8.21626 7.48567 8.23191 7.56494 8.23179 7.64496C8.23167 7.72499 8.21578 7.80421 8.18503 7.8781C8.15428 7.95199 8.10927 8.01909 8.05257 8.07557Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnread);
export default ForwardRef;